<template>
  <div class="h-full bg-slate-100 dark:bg-zinc-800">
    <a
      href="#main-content"
      class="sr-only fixed left-4 top-4 z-[100] rounded-md bg-white px-4 py-2 text-slate-900 shadow-lg
        focus:not-sr-only"
    >
      Skip to main content
    </a>
    <dashboard-sidebar />
    <div class="relative min-h-full bg-slate-100 dark:bg-zinc-800 md:ml-64">
      <app-navbar v-if="authorized" />
      <div
        v-if="authorized"
        class="relative bg-primary pb-32 pt-6 md:pt-16"
      />
      <div
        v-else
        class="relative pb-32 pt-6 md:pt-16"
      />
      <main
        id="main-content"
        tabindex="-1"
        class="-m-24 mx-auto size-full px-4 md:px-10"
      >
        <router-view v-if="authorized" />
        <error-view-403 v-else />
        <footer-admin />
      </main>
    </div>
  </div>
</template>
<script setup lang="ts">
import AppNavbar from '../components/Navbars/AppNavbar.vue';
import DashboardSidebar from '../components/Sidebar/DashboardSidebar.vue';
import FooterAdmin from '../components/Footers/FooterAdmin.vue';
import ErrorView403 from '../views/403ErrorView.vue';
import { useStore } from '../api/index.ts';
import { onMounted, computed } from 'vue';

const store = useStore();
const authorized = computed(() => {
  return (
    store.system.permissions &&
    (store.system.permissions.includes('administrator') || store.system.permissions.includes('moderator')));
});

onMounted(async () => {
  await store.watchSystemPermissions();
});

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.favicon) {
  let link = document.querySelector<HTMLLinkElement>('link[rel~=\'icon\']');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.favicon;
}
</script>
